import React from 'react';
import { ShowcaseCard, ShowcaseCardProps } from '../ShowcaseCard/ShowcaseCard';
import { styles } from './ShowcaseCarousel.css';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import 'swiper/swiper-bundle.min.css';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

interface ShowcaseCarouselProps {
  showcaseCards: Array<ShowcaseCardProps>;
  className?: string;
  backgroundColor?: string;
}

export const ShowcaseCarousel = ({ showcaseCards, className, backgroundColor }: ShowcaseCarouselProps) => {
  const isMobile = !useBreakpoint('md', 'up');
  if (!showcaseCards?.length) return null;
  return (
    <div className={classNames([className, styles.showcaseCarouselWrapper])}>
      <div className={styles.showcaseCarouselItem}>
        {isMobile ? (
          <Carousel variant="cards" fullBleed={true} progressBarBulletShape="dash">
            {showcaseCards.map((card, index) => {
              return <ShowcaseCard key={index} backgroundColor={backgroundColor} {...card} />;
            })}
          </Carousel>
        ) : (
          showcaseCards.map((card, index) => <ShowcaseCard key={index} backgroundColor={backgroundColor} {...card} />)
        )}
      </div>
    </div>
  );
};
